import { Modal } from 'bootstrap/dist/js/bootstrap.bundle.js';


(function() {

   // relatedTarget

  var form = document.getElementById('contactForm')

  var successMessage = document.getElementById('successMessage')
  
  var modal = new Modal(document.getElementById('modalForm'), {})

	form.addEventListener('submit', function (event) {
		event.preventDefault();
    //var url = "https://meetbeep.com/mail.php"; 
    var url = "https://iyfujgydrro566cypxnjn6es6m0sdrsw.lambda-url.us-east-1.on.aws/"; 
    

    var xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4          
           if (xmlhttp.status == 200) {
              console.log('hide')
              hideForm();
              setTimeout(hideModal, 2000);
           }
           else {
               alert('Error sending message.');
           }
        }
    };

    xmlhttp.open("POST", url, true);
    xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xmlhttp.send('subject='+form.subject.value+'&email='+form.email.value+'&name='+form.name.value+'&message='+form.message.value);



	}, false)

  var hideForm = function(){
    form.style.display = "none"; 
    successMessage.style.display = "block"; 
  };

  var showForm = function(){
    form.style.display = "block"; 
    successMessage.style.display = "none"; 
  };  

  var hideModal = function(){
    modal.hide();
    form.reset();
    setTimeout(showForm, 1000);
  };



})();

